/**
 * Boss Fighting Game - Entry Point
 *
 * A colorful cartoon-style boss fighting game for kids (8+ years).
 * Features 5 unique bosses, 1-2 player support, and 3 difficulty levels.
 *
 * Built with PlayCanvas WebGL engine.
 */

import { Game } from './core/game.js';

// Start game when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    // Get canvas element
    const canvas = document.getElementById('application');

    if (!canvas) {
        console.error('Canvas element not found!');
        return;
    }

    // Create game instance
    const game = new Game(canvas);

    // Initialize the game
    game.init();

    // Show main menu
    game.showMenu();
});
